import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { IsLoggedGuard } from './@core/guards/is-logged.guard';
import { IsSubscriptionIsExpireddGuard } from './@core/guards/is-subscription-expired.guard';
import { ErrorPageComponent } from './pages/error-page/error-page.component';
import { OpenConnectComponent } from './pages/open-connect/open-connect.component';


const routes: Routes = [
    {
        path: '',
        loadChildren: () => import('./pages/homepage/homepage.module').then(module => module.HomepageModule),
        data: { preload: true }
    },
    {
        path: 'site/:siteId',
        loadChildren: () => import('./pages/homepage/homepage.module').then(module => module.HomepageModule),
        data: { preload: true }
    },
    {
        path: 'builder',
        loadChildren: () => import('./pages/builder/builder.module').then(module => module.BuilderModule),
        canActivate: [IsLoggedGuard, IsSubscriptionIsExpireddGuard],
        data: { preload: true }
    },
    {
        path: 'blog',
        loadChildren: () => import('./pages/blog/blog.module').then(module => module.BlogModule),
        data: { preload: true }
    },
    {
        path: 'cart',
        loadChildren: () => import('./pages/cart/cart.module').then(module => module.CartModule),
        data: { preload: true }
    },
    {
        path: 'order-track',
        loadChildren: () => import('./pages/order-track/order-track.module').then(module => module.OrderTrackModule),
        data: { preload: true }
    },
    {
        path: 'checkout',
        loadChildren: () => import('./pages/checkout-order/checkout-order.module').then(module => module.CheckoutOrderModule),
        data: { preload: true }
    },
    {
        path: 'shop/product/:id/:title',
        loadChildren: () => import('./pages/shop/shop.module').then(module => module.ShopModule),
        data: { preload: true }
    },
    {
        path: 'tos',
        loadChildren: () => import('./pages/terms-conditions/terms-conditions.module').then(module => module.TermsofServiceModule),
        data: { preload: true }
    },
    {
        path: 'suspended',
        loadChildren: () => import('./pages/suspended/suspended.module').then(module => module.SuspendedModule),
        data: { preload: true }
    },
    {
        path: 'privacy-policy',
        loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(module => module.PrivacyPolicyModule),
        data: { preload: true }
    },
    { path: 'error/:errorCode', component: ErrorPageComponent },
    // { path: 'blog/:category/:siteId/:createdAt', component: ViewArticleComponent},
    { path: 'open-connect/:openToken', component: OpenConnectComponent },
    { path: '**', redirectTo: 'error/404', pathMatch: 'full' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes, {
        initialNavigation: 'enabled'
    })],
    exports: [RouterModule],
    declarations: []
})
export class AppRoutingModule { }
